(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[177],{

/***/ 1400:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-story",
      function () {
        return __webpack_require__(3810);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1292:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hero-banner-bg.dc0c0f4f.jpeg","height":575,"width":1400,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAADAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAZEAADAQEBAAAAAAAAAAAAAAAAARECEiH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAFREBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhEDEQA/AJfrT4t9SUAAMLX/2Q==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 2555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6180);
/* harmony import */ var _public_assets_hero_banner_bg_jpeg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1292);
/* harmony import */ var _hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4493);





function PageTitle(param) {
    var topComponent = param.topComponent, title = param.title, description = param.description, className = param.className;
    var useHighContrast = (0,_hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_3__/* .useAccessibilitySettings */ .C)().useHighContrast;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("pt-12 pb-12 lg:pt-20 lg:pb-20", useHighContrast ? "bg-contrast-yellow text-black" : "", className),
        style: {
            backgroundImage: useHighContrast ? "unset" : "url(".concat(_public_assets_hero_banner_bg_jpeg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src, ")"),
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center top",
            backgroundSize: "cover"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container flex flex-col items-center",
            children: [
                topComponent,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("text-4xl font-medium text-center", useHighContrast ? "text-inherit" : "text-white", description ? "mb-8" : null, topComponent ? "mt-4" : null),
                    children: title
                }),
                description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_4__/* .twMerge */ .m)("text-xl font-light text-center max-w-[760px]", useHighContrast ? "text-inherit" : "text-white"),
                    children: description
                }) : null
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageTitle);


/***/ }),

/***/ 3618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ utils_SEO; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./config/site.config.ts
var siteConfig = Object.freeze({
    title: "GoodFoodTalks",
    description: "GoodFoodTalks",
    twitterCreator: "@GoodFoodTalks"
});

;// CONCATENATED MODULE: ./components/utils/SEO.tsx



function SEO(param) {
    var pageTitle = param.title, description = param.description, socialImageSrc = param.socialImageSrc;
    var siteTitle = siteConfig.title, siteDescription = siteConfig.description, twitterCreator = siteConfig.twitterCreator;
    var title = "".concat(pageTitle, " | ").concat(siteTitle);
    var metaDescription = description !== null && description !== void 0 ? description : siteDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: metaDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:site_name",
                content: siteTitle
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:creator",
                content: twitterCreator
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: metaDescription
            }),
            socialImageSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: socialImageSrc
            }) : null
        ]
    });
}
/* harmony default export */ var utils_SEO = (SEO);


/***/ }),

/***/ 3810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9583);
/* harmony import */ var tailwind_merge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6180);
/* harmony import */ var _hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4493);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1284);
/* harmony import */ var _components_sections_PageTitle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2555);
/* harmony import */ var _components_utils_SEO__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3618);







var OurStory = function() {
    var useHighContrast = (0,_hooks_useAccessibilitySettings__WEBPACK_IMPORTED_MODULE_1__/* .useAccessibilitySettings */ .C)().useHighContrast;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_utils_SEO__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "Our Story",
                description: "Our Story"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_PageTitle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                topComponent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_5__/* .FaUsers */ .I$, {
                    className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_6__/* .twMerge */ .m)("h-20 w-20", useHighContrast ? "text-black" : "text-primary-600"),
                    "aria-hidden": "true"
                }),
                title: "Our Story",
                description: "Good Food Talks was founded in March 2013 and is the brainchild of Matt Wadsworth and Kate Bennett Wadsworth. It continues to grow rapidly today but here is how it all started:"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                className: (0,tailwind_merge__WEBPACK_IMPORTED_MODULE_6__/* .twMerge */ .m)("py-20", useHighContrast ? "bg-contrast-yellow text-black" : "bg-[#f3f3e0]"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container space-y-14 font-light",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "space-y-4",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "Visually impaired people are sociable creatures. They love food, wine and beer, and above all else, they value their independence. Basically, they just want to be treated like anybody else."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "There’s something about the restaurant experience, though, that can often make you feel like some kind of special needs case. You’ve either got a dining companion reading the menu, or you’ve got a hurried waiter, who, with the best will in the world, just doesn’t have time to read everything out loud. Then there are Braille menus – a nice gesture on the restaurant’s part, but if you try grappling your way through a Braille menu, everybody else has ordered and you’re still reading through the starters."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "With our shared passion for creative problem solving, we put our heads together to invent a universally accessible restaurant menu – the kind of thing someone could read as casually and effortlessly as an ordinary menu. After 4 months of research and testing, we figured out that the ideal medium for this was the device everyone already had in their pockets."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "We live in an incredible age of technology. Matt remembers a time when deciding to read a book meant ordering the special Braille version – if it even existed – and then hoping it arrived (in multiple volumes) before you decided you’d rather read a different book. Now, he just orders ordinary e-books for his Kindle app and reads them on his phone.Most smartphones, tablets and computers now come with a host of customizable accessibility features, including a built in screen reader that will speak everything out loud."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "For people who have limited vision, you can also enlarge the print, highlight buttons, and even invert all the colours. Every time you upgrade your phone or your operating system, you’ll notice more of these choices."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    "Optimising a menu for all of these features at once has proved to be a huge challenge and great commitment – as has making sure that the menus on our system are always up to date. It’s definitely a challenge, but Matt has been known to get a bit of a kick out of challenges .",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "We never rest, and are always developing, learning, innovating and improving. right now, it just feels like a great honour to be able to use technology and accessibility to bring value to the restaurant industry."
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (OurStory);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,314,284,774,888,179], function() { return __webpack_exec__(1400); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);